var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImportHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.998,
    height: 20.008,
    viewBox: "0 0 19.998 20.008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_541",
    "data-name": "Union 541",
    d: "M13722.888-18791.555a5.564,5.564,0,0,1,5.555-5.555,5.564,5.564,0,0,1,5.556,5.555,5.563,5.563,0,0,1-5.556,5.561A5.563,5.563,0,0,1,13722.888-18791.555Zm3.087.2a.668.668,0,0,0,0,.943l2,2a.67.67,0,0,0,.472.2.657.657,0,0,0,.473-.2l2-2a.67.67,0,0,0,0-.943.657.657,0,0,0-.473-.2.657.657,0,0,0-.472.2l-.863.863v-3.725a.67.67,0,0,0-.666-.67.672.672,0,0,0-.665.67v3.719l-.859-.857a.662.662,0,0,0-.472-.2A.646.646,0,0,0,13725.975-18791.355Zm-2.657,5.355h0Zm-6.315,0a3,3,0,0,1-3-3v-14a3.007,3.007,0,0,1,3-3h5.584a2.061,2.061,0,0,1,1.415.586l5.414,5.418a2,2,0,0,1,.547,1.043,7.429,7.429,0,0,0-1.52-.156,7.554,7.554,0,0,0-5.238,2.109H13719a1,1,0,0,0-1,1.006,1,1,0,0,0,1,1h2.719a7.551,7.551,0,0,0-.693,2.006H13719a1,1,0,0,0-1,1,1,1,0,0,0,1,1h1.907a7.542,7.542,0,0,0,2.412,5Zm10.775-4.5v.006Z",
    transform: "translate(-13714 18806.002)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportHover);
export default __webpack_public_path__ + "static/media/ImportHover.7d089c80162bf8368853a93c9ac5120b.svg";
export { ForwardRef as ReactComponent };